<template>
  <div class="tags-container">
    <!-- 一级标签 -->
    <div style="border-bottom: 1px solid #E8E8E8;">
      <div class="first-label container_media">
        <div
          class="first-label__item"
          @mouseenter="activateFirstTag({ label_id: -1 })"
        >
          <img :src="require(`@/assets/svg/tag/${firstActiveKey == -1 ? 'all_select_icon' : 'all_icon'}.svg`)" alt="">
          <span :style="{ color: `${firstActiveKey == -1 ? '#E52A0D' : '#666666'}`}">全部</span>
        </div>
        <div
          v-for="tag in tagsList"
          :key="tag.label_id"
          class="first-label__item"
          @mouseenter="activateFirstTag(tag)"
        >
          <img :src="require(`@/assets/svg/tag/${firstActiveKey == tag.label_id ? tag.active_icon : tag.default_icon}.svg`)" alt="">
          <span :style="{ color: `${firstActiveKey == tag.label_id ? '#E52A0D' : '#666666'}`}">{{tag.label_name}}</span>
        </div>
      </div>
    </div>

    <div class="others">
      <div class="container_media">

        <!-- 全部模式：四类标签（单行，按容器宽度截断） -->
        <div v-if="firstActiveKey === -1" class="all-categories">
          <div
            v-for="category in allCategoryTags"
            :key="`cat_${category.label_id}`"
            class="category-block"
            :data-category="category.label_id"
          >
            <div class="second-label">
              <div class="title">{{ category.label_name }}：</div>
              <div class="tags-wrap all-tags-row">
                <span
                  v-for="sonTag in getVisibleSonTags(category)"
                  :key="`son_${sonTag.label_id}`"
                  class="all-tag-item"
                  @click="handleTagClick(sonTag, category)"
                  :class="{ 'active_label': isAllModeSecondActive(category.label_id, sonTag) || isActive(sonTag) }"
                >
                  {{ sonTag.label_name }}
                </span>
                <span
                  v-if="tagsLayoutReady && needsToggle[category.label_id]"
                  class="toggle-more"
                  @click.stop="openCategoryTab(category)"
                >更多>></span>
              </div>
            </div>
            <div
              v-if="getAllModeThirdList(category.label_id).length"
              class="third-label"
            >
              <div class="tags-wrap">
                <span
                  v-for="tTag in getAllModeThirdList(category.label_id)"
                  :key="`all_t_${tTag.label_id}`"
                  @click="chooseThirdTag(tTag)"
                  :class="{ 't_active_label': chooseTagList.some(t => t.label_id === tTag.label_id) }"
                >
                  {{ tTag.label_name }}
                </span>
              </div>
            </div>
          </div>
          <!-- 隐藏测量区：与展示标签同样式，用于计算宽度 -->
          <div ref="measureRuler" class="tags-measure-ruler" aria-hidden="true">
            <div
              v-for="category in allCategoryTags"
              :key="`measure_${category.label_id}`"
              :data-measure-row="category.label_id"
              class="tags-wrap"
            >
              <span
                v-for="sonTag in category.son"
                :key="`m_${sonTag.label_id}`"
                class="all-tag-item measure-tag-span"
              >{{ sonTag.label_name }}</span>
            </div>
            <span ref="moreMeasure" class="toggle-more">更多...</span>
          </div>
        </div>

        <!-- 单分类模式 -->
        <div class="second-label" v-else-if="firstActiveKey != -1">
          <div class="title">{{ firstActiveTag.label_name }}：</div>
          <div class="tags-wrap">
            <span
              v-for="sonTag in firstActiveTag.son"
              :key="`sonTag_${sonTag.label_id}`"
              @click="chooseSecondTag(sonTag)"
              :class="{ 'active_label': chooseTagList.includes(sonTag) || secondActiveKey.label_id == sonTag.label_id }"
            >
              {{ sonTag.label_name }}
            </span>
          </div>
        </div>

        <!-- 原有三级区域（兼容旧逻辑） -->
        <div class="third-label" v-if="thirdTagsList.length && firstActiveKey !== -1">
          <div class="tags-wrap">
            <span
              v-for="tTag in thirdTagsList"
              :key="`tTag${tTag.label_id}`"
              @click="chooseThirdTag(tTag)"
              :class="{ 't_active_label': chooseTagList.includes(tTag) }"
            >
              {{ tTag.label_name }}
            </span>
          </div>
        </div>

        <!-- 时长、速度、排序等 -->
        <div class="time">
          <div class="title">时长：</div>
          <div v-for="time in timeList" :key="`time_${time.value}`" @click="chooseTime(time.value)">
            <strong v-if="timeChooseValue == time.value"><b></b></strong>
            <i v-else></i>
            {{time.name}}
          </div>
        </div>
        <div class="speed_all">
          <div class="title">速度：</div>
          <div class="speed">
            <div v-for="speed in speedList" :key="`speed_${speed.value}`" @click="chooseSpeed(speed.value)">
              <strong v-if="speedChooseValue == speed.value"><b></b></strong>
              <i v-else></i>
              {{speed.name}}
            </div>
          </div>
          <em></em>
          <div class="sort">
            <div class="title">排序：</div>
            <div v-for="sort in orderList" :key="`sort_${sort.value}`" @click="chooseSort(sort.value)" :class="{'active_label': sortChooseValue == sort.value}">{{sort.label}}</div>
          </div>
          <div class="tag-pagina">
            <i class="pagina_l el-icon-arrow-left" :class="{ 'active': lpage }" @click="prevPage"></i>
            <span class="pager">
              <i class="page">{{ pager.page }}</i>
              <i class="pagesize">/...</i>
            </span>
            <i class="pagina_r el-icon-arrow-right" :class="{ 'active': rpage }" @click="nextPage"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 标签选中结果 -->
    <div v-if="chooseTagList.length || timeChooseValue || speedChooseValue" class="selected-tag-box container_media">
      <span class="title"><i>音乐列表</i><em>|</em> 已选标签：</span>
      <el-tag v-for="item in chooseTagList" :key="`check_${item.label_id}`" size="small" closable
        @close="handleCloseTag(item)">{{ item.label_name }}</el-tag>
      <el-tag v-if="timeChooseValue" size="small" closable @close="timeChooseValue=''">{{ toLabelName('timeChooseValue','timeList') }}</el-tag>
      <el-tag v-if="speedChooseValue" size="small" closable @close="speedChooseValue=''">{{ toLabelName('speedChooseValue','speedList')}}</el-tag>
      <span class="clean" @click="cleanTagSearch">全部清除</span>
    </div>
  </div>
</template>

<script>
import { fetchMusicTags } from '@/api/music'
import { orderList } from '@/config'

export default {
  name: 'TagsFilterNew',
  data() {
    return {
      tagsList: [],
      firstActiveTag: {}, // 被选择的一级标签对象 firstActiveTag.son为被选中的二级列表
      firstActiveKey: -1, // 标签列表一级选中下标 默认显示全部
      secondActiveKey: {}, // 包含三级标签的二级标签被选中
      chooseTagList: [], // 被选中的二级标签
      thirdTagsList: [], // 被选中的三级列表 待补全逻辑
      timeChooseValue: '',
      speedChooseValue: '',
      sortChooseValue: '',
      orderList,
      lpage: false,
      rpage: false,

      needsToggle: {}, // { categoryId: boolean } 是否显示「更多」
      visibleCount: {}, // { categoryId: number } 单行可见标签数量
      tagsLayoutReady: false, // 宽度计算完成后再展示标签，避免首屏全量挤压
      allModeExpanded: {}, // 全部模式：{ [categoryId]: { parentTag } }
      resizeObserver: null,

      // expandedCategories: {}, // 行内展开已废弃

      timeList: [{
        name: '全部',
        value: '',
      }, {
        name: '小于30秒',
        value: 1,
      }, {
        name: '30秒-1分钟',
        value: 2,
      }, {
        name: '1分钟-2分钟',
        value: 3,
      }, {
        name: '2分钟-3分钟',
        value: 4,
      }, {
        name: '3分钟以上',
        value: 5,
      }],
      speedList: [{
        name: '全部',
        value: '',
      }, {
        name: '慢（BPM 0～60）',
        value: 1,
      }, {
        name: '中（BPM 60～100）',
        value: 2,
      }, {
        name: '快（BPM 100以上）',
        value: 3,
      }]
    }
  },

  props: {
    pager: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    // 提取四个固定分类，并按指定顺序排列
    allCategoryTags() {
      const targetNames = ['情绪', '风格', '配器', '场景'];
      return this.tagsList
        .filter(tag => targetNames.includes(tag.label_name))
        .sort((a, b) => targetNames.indexOf(a.label_name) - targetNames.indexOf(b.label_name));
    },
    pages() {
      return Math.ceil(this.pager.total / this.pager.limit);
    }
  },
  created(){
    this.getTagList()
  },
  mounted() {
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.firstActiveKey === -1 && this.allCategoryTags.length) {
          this.calculateToggles();
        }
      });
      this.$nextTick(() => {
        const target = this.$el.querySelector('.all-categories') || this.$el;
        if (target && this.resizeObserver) {
          this.resizeObserver.observe(target);
        }
      });
    }
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    window.removeEventListener('resize', this.onWindowResize);
  },
  watch: {
    firstActiveKey(val) {
      if (val === -1) {
        this.scheduleCalculateToggles();
      }
    },
  },
  methods: {
    onWindowResize() {
      if (this.firstActiveKey === -1 && this.allCategoryTags.length) {
        this.calculateToggles();
      }
    },
    scheduleCalculateToggles() {
      this.tagsLayoutReady = false;
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.calculateToggles();
          });
        });
      });
    },
    getSpanOuterWidth(el) {
      if (!el) return 0;
      const rect = el.getBoundingClientRect();
      if (rect.width <= 0) return 0;
      const style = window.getComputedStyle(el);
      const marginLeft = parseFloat(style.marginLeft) || 0;
      const marginRight = parseFloat(style.marginRight) || 0;
      return rect.width + marginLeft + marginRight;
    },
    getTagsWrapMaxWidth(categoryId) {
      const categoryBlock = this.$el.querySelector(`[data-category="${categoryId}"]`);
      if (!categoryBlock) return 0;
      const wrap = categoryBlock.querySelector('.all-tags-row') || categoryBlock.querySelector('.tags-wrap');
      const title = categoryBlock.querySelector('.title');
      const titleWidth = title ? title.offsetWidth : 46;
      const rowWidth = categoryBlock.clientWidth;
      if (wrap && wrap.clientWidth > 0) {
        return wrap.clientWidth;
      }
      return Math.max(0, rowWidth - titleWidth);
    },
    applyCategoryLayout(categoryId, sons, needsToggle, count) {
      const len = sons.length;
      let visible = count;
      let toggle = needsToggle;
      if (toggle) {
        if (visible >= len) {
          visible = Math.max(0, len - 1);
        }
      } else {
        visible = len;
      }
      this.$set(this.needsToggle, categoryId, toggle);
      this.$set(this.visibleCount, categoryId, visible);
    },
    calculateToggles() {
      if (this.firstActiveKey !== -1 || !this.allCategoryTags.length) return;
      const ruler = this.$refs.measureRuler;
      const moreEl = this.$refs.moreMeasure;
      if (!ruler || !moreEl) return;

      const moreWidth = this.getSpanOuterWidth(moreEl);
      if (moreWidth <= 0) {
        setTimeout(() => this.calculateToggles(), 100);
        return;
      }

      let measureInvalid = false;

      this.allCategoryTags.forEach((category) => {
        const sons = category.son || [];
        const measureRow = ruler.querySelector(
          `[data-measure-row="${category.label_id}"]`
        );
        if (!measureRow || !sons.length) {
          this.applyCategoryLayout(category.label_id, sons, false, sons.length);
          return;
        }

        const containerWidth = this.getTagsWrapMaxWidth(category.label_id);
        if (containerWidth <= 0) {
          measureInvalid = true;
          return;
        }

        const tagSpans = measureRow.querySelectorAll('.measure-tag-span');
        const tagWidths = Array.from(tagSpans).map((span) => this.getSpanOuterWidth(span));
        if (tagWidths.some((w) => w <= 0)) {
          measureInvalid = true;
          return;
        }

        const totalWidth = tagWidths.reduce((sum, w) => sum + w, 0);

        if (totalWidth <= containerWidth) {
          this.applyCategoryLayout(category.label_id, sons, false, sons.length);
          return;
        }

        const available = containerWidth - moreWidth;
        let used = 0;
        let count = 0;
        for (let i = 0; i < tagWidths.length; i++) {
          if (used + tagWidths[i] <= available) {
            used += tagWidths[i];
            count++;
          } else {
            break;
          }
        }

        this.applyCategoryLayout(category.label_id, sons, true, count);
      });

      if (measureInvalid) {
        setTimeout(() => this.calculateToggles(), 100);
        return;
      }

      this.tagsLayoutReady = true;
    },
    getVisibleSonTags(category) {
      const sons = category.son || [];
      if (!this.tagsLayoutReady) return [];
      const count = this.visibleCount[category.label_id];
      if (count === undefined) return [];
      return sons.slice(0, count);
    },
    resolveFirstTag(tag) {
      if (!tag || tag.label_id === -1) {
        return { label_id: -1 };
      }
      return this.tagsList.find((t) => t.label_id === tag.label_id) || tag;
    },
    restoreTabExpandState() {
      this.thirdTagsList = [];
      this.secondActiveKey = {};
      const sons = this.firstActiveTag.son || [];
      if (!sons.length || !this.chooseTagList.length) return;

      const chosenIds = new Set(this.chooseTagList.map((t) => t.label_id));
      for (let i = 0; i < sons.length; i++) {
        const secondTag = sons[i];
        if (!this.hasTagChildren(secondTag)) continue;
        const hasChosenChild = secondTag.son.some((child) => chosenIds.has(child.label_id));
        if (hasChosenChild) {
          this.secondActiveKey = secondTag;
          this.thirdTagsList = secondTag.son;
          return;
        }
      }
    },
    restoreAllModeExpandState() {
      this.allModeExpanded = {};
      if (!this.chooseTagList.length || !this.allCategoryTags.length) return;

      const chosenIds = new Set(this.chooseTagList.map((t) => t.label_id));
      this.allCategoryTags.forEach((category) => {
        const sons = category.son || [];
        for (let i = 0; i < sons.length; i++) {
          const secondTag = sons[i];
          if (!this.hasTagChildren(secondTag)) continue;
          if (secondTag.son.some((child) => chosenIds.has(child.label_id))) {
            this.$set(this.allModeExpanded, category.label_id, { parentTag: secondTag });
            break;
          }
        }
      });
    },
    activateFirstTag(tag) {
      const resolved = this.resolveFirstTag(tag);
      if (resolved.label_id === -1) {
        this.firstActiveTag = { label_id: -1 };
        this.firstActiveKey = -1;
        this.thirdTagsList = [];
        this.secondActiveKey = {};
        this.restoreAllModeExpandState();
        this.scheduleCalculateToggles();
      } else {
        this.firstActiveTag = resolved;
        this.firstActiveKey = resolved.label_id;
        this.allModeExpanded = {};
        this.restoreTabExpandState();
      }
    },
    openCategoryTab(category) {
      const tag = this.tagsList.find((t) => t.label_id === category.label_id) || category;
      this.activateFirstTag(tag);
    },
    clearAllModeExpanded(categoryId) {
      if (categoryId === undefined || categoryId === null) {
        this.allModeExpanded = {};
        return;
      }
      this.$delete(this.allModeExpanded, categoryId);
    },
    getAllModeThirdList(categoryId) {
      const expanded = this.allModeExpanded[categoryId];
      if (!expanded || !expanded.parentTag || !expanded.parentTag.son) return [];
      return expanded.parentTag.son;
    },
    isAllModeSecondActive(categoryId, tag) {
      const expanded = this.allModeExpanded[categoryId];
      return !!(expanded && expanded.parentTag && expanded.parentTag.label_id === tag.label_id);
    },
    hasTagChildren(tag) {
      return !!(tag.son && tag.son.length);
    },
    toggleSecondWithChildren(tag, options = {}) {
      const { mode = 'tab', categoryId } = options;

      if (this.hasTagChildren(tag)) {
        if (mode === 'all') {
          const parentIdx = this.chooseTagList.findIndex((i) => i.label_id === tag.label_id);
          if (parentIdx > -1) {
            this.chooseTagList.splice(parentIdx, 1);
            this.handleGet();
          }
          const expanded = this.allModeExpanded[categoryId];
          if (expanded && expanded.parentTag && expanded.parentTag.label_id === tag.label_id) {
            this.clearAllModeExpanded(categoryId);
          } else {
            this.$set(this.allModeExpanded, categoryId, { parentTag: tag });
          }
        } else if (this.secondActiveKey.label_id === tag.label_id) {
          this.thirdTagsList = [];
          this.secondActiveKey = {};
        } else {
          this.thirdTagsList = tag.son;
          this.secondActiveKey = tag;
        }
        return;
      }

      const index = this.chooseTagList.findIndex((i) => i.label_id === tag.label_id);
      if (index > -1) {
        this.chooseTagList.splice(index, 1);
      } else {
        this.chooseTagList.push(tag);
      }
      if (mode === 'all') {
        this.clearAllModeExpanded(categoryId);
      } else {
        this.thirdTagsList = [];
        this.secondActiveKey = {};
      }
      this.handleGet();
    },
    // toggleExpand(categoryId) {
    //   const newState = !this.expandedCategories[categoryId];
    //   this.$set(this.expandedCategories, categoryId, newState);
    // },
    // isExpanded(categoryId) {
    //   return this.expandedCategories[categoryId] === true;
    // },
    // isCollapsed(categoryId) {
    //   return this.expandedCategories[categoryId] !== true;
    // },
    // shouldShowToggle(categoryId) {
    //   return this.needsToggle[categoryId];
    // },
    // isTagVisible(category, index) {
    //   if (this.expandedCategories[category.label_id]) return true;
    //   return index < this.maxVisibleTags;
    // },
    // hasMore(category) {
    //   return category.son && category.son.length > this.maxVisibleTags;
    // },
    // chooseSecondTagFromAll(tag, parentTag) { ... },
    // visibleSonTags(category) {
    //   return category.son ? category.son.slice(0, this.maxVisibleTags) : [];
    // },
    // chooseFirstTag 已移除：一级 Tab 仅 mouseenter 切换，避免与悬浮后的 click toggle 冲突

    chooseSecondTag(tag) {
      this.toggleSecondWithChildren(tag, { mode: 'tab' });
    },
    chooseThirdTag(tag) {
      const index = this.chooseTagList.findIndex((i) => i.label_id === tag.label_id);
      if (index > -1) {
        this.chooseTagList.splice(index, 1);
      } else {
        this.chooseTagList.push(tag);
      }
      if (this.firstActiveKey === -1) {
        this.restoreAllModeExpandState();
      } else {
        this.restoreTabExpandState();
      }
      this.handleGet();
    },
    chooseTime(v){
      if(this.timeChooseValue == v) return
      this.timeChooseValue = v
      this.handleGet()
    },
    chooseSpeed(v){
      if(this.speedChooseValue == v) return
      this.speedChooseValue = v
      this.handleGet()
    },
    chooseSort(v){
      if(this.sortChooseValue == v) return
      this.sortChooseValue = v
      this.handleGet()
    },
    prevPage() {
      if (this.pager.page < 2) return;
      this.pager.page--;
      this.$emit('pageChange')
      this.lpage = true;
      this.rpage = false;
    },
    nextPage() {
      console.log(this.pager, this.pages);
      if (this.pager.page < this.pages) {
        this.pager.page++;
        this.$emit('pageChange')
        this.lpage = false;
        this.rpage = true;
      }
    },
    toLabelName(key,listKey){
      const index = this[listKey].findIndex((i) => i.value === this[key])
      return this[listKey][index].name
    },
    // 清除单个标签
    handleCloseTag(item) {
      const index = this.chooseTagList.findIndex((i) => i.label_id === item.label_id)
      this.chooseTagList.splice(index, 1)
      this.handleGet()
    },
    // 全部清除标签
    cleanTagSearch() {
      this.timeChooseValue = '';
      this.speedChooseValue = '';
      this.chooseTagList = [];
      this.thirdTagsList = [];
      // this.thirdTagsMap = {};
      this.secondActiveKey = {};
      this.firstActiveKey = -1;
      this.firstActiveTag = { label_id: -1 };
      this.needsToggle = {};
      this.visibleCount = {};
      this.tagsLayoutReady = false;
      this.allModeExpanded = {};
      this.handleGet();
      this.scheduleCalculateToggles();
    },
    handleGet(){
      this.$emit('getList', {
        bpm: this.speedChooseValue,
        duration: this.timeChooseValue,
        order: this.sortChooseValue,
        label_id: this.chooseTagList.map(i => i.label_id).join(',')
      });
    },
    async getTagList() {
      try {
        const { data } = await fetchMusicTags();
        this.tagsList = data.map(e => {
          if (e.label_name === '场景') {
            e.active_icon = 'scene_select_icon';
            e.default_icon = 'scene_icon';
          } else if (e.label_name === '情绪') {
            e.active_icon = 'feel_select_icon';
            e.default_icon = 'feel_icon';
          } else if (e.label_name === '风格') {
            e.active_icon = 'style_select_icon';
            e.default_icon = 'style_icon';
          } else if (e.label_name === '配器') {
            e.active_icon = 'tool_select_icon';
            e.default_icon = 'tool_icon';
          }
          return e;
        });
        this.scheduleCalculateToggles();
      } catch (e) {
        console.error('Failed to load tags:', e);
      }
    },

    handleTagClick(tag, category) {
      this.toggleSecondWithChildren(tag, {
        mode: 'all',
        categoryId: category.label_id,
      });
    },

    isActive(tag) {
      return this.chooseTagList.some((t) => t.label_id === tag.label_id);
    },
  }
}
</script>

<style lang="scss" scoped>

.all-categories {
  position: relative;
}

.category-block {
  .second-label {
    display: flex;
  }
}

.all-tags-row {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  align-items: center;
  min-width: 0;

  > .all-tag-item,
  > .toggle-more {
    flex-shrink: 0;
    white-space: nowrap;
  }
}

.tags-measure-ruler {
  position: fixed;
  left: -10000px;
  top: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: -1;
  white-space: nowrap;

  .tags-wrap {
    display: flex;
    flex-wrap: nowrap;
  }

  .all-tag-item {
    flex-shrink: 0;
    white-space: nowrap;
  }
}

// .tags-wrap.measure { display: flex; flex-wrap: wrap; }
// .tags-wrap.collapsed { -webkit-line-clamp: 1; ... }

.toggle-more {
  color: #E52A0D;
  cursor: pointer;
  margin-left: 6px;
  flex-shrink: 0;
}

/* ========== 保留原有样式 ========== */
.tags-container{
  width: 100%;
  margin-bottom: 10px;
  color: #666;
  font-size: 14px;
}
.first-label {
  height: 56px;
  display: flex;
  align-items: center;
  div{
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-right: 30px;
    span{
      font-weight: 500;
      margin-left: 6px;
      &:hover{
        color: #E52A0D!important;
      }
    }
  }
}
.others{
  background: #FFFFFF;
  box-shadow: 0px 5px 9px 0px rgba(0,0,0,0.1);
  padding: 8px 0 14px 0;
  .speed_all {
    display: flex;
    align-items: center;
    position: relative;
    em{
      width: 1px;
      height: 14px;
      background: #D8D8D8;
      margin: 0 30px;
    }
  }
  .title {
    width: 46px;
    height: 24px;
    line-height: 24px;
    font-weight: 500;
  }
  .time, .speed_all {
    padding: 8px 0;
  }
  .time, .speed {
    display: flex;
    div:not(.title){
      cursor: pointer;
      height: 24px;
      line-height: 24px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      position: relative;

      &:hover {
        color: #E52A0D;
      }
      &::before{
        content: '';
        display: inline-block;
        width: 14px;
        height: 14px;
        // border-radius: 50%;
        // border: 1px solid #ccc;
        margin-right: 10px;
      }
      i{
        position: absolute;
        top: 5px;
        left: 10px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 1px solid #ccc;
        margin-right: 10px;
      }
      strong{
        position: absolute;
        top: 5px;
        left: 10px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 1px solid #E52A0D;
        margin-right: 10px;
        b {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 4px;
          height: 4px;
          background: #E52A0D;
          border-radius: 50%;
        }
      }
    }
  }
  .sort{
    display: flex;
  }
  .sort, .tags-wrap {
    // display: flex;
    div:not(.title), span{
      cursor: pointer;
      height: 24px;
      line-height: 24px;
      padding: 0 10px;
      background: #fff;
      border-radius: 4px;
      margin-right: 10px;
      &:hover{
        background: #FDF4F3;
      }
    }
  }
  .tag-pagina {
    @include center-middle-flex($justify: flex-start);
    position: absolute;
    right: 0;
    i {
      font-style: normal;
      display: inline-block;
    }

    .pagina_l,
    .pagina_r {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      cursor: pointer;
    }

    .pager {
      margin: 0 15px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
    }

    .page {
      color: #E52A0D;
    }

    .active {
      border-color: #E52A0D;
      color: #E52A0D;
    }
  }
}
.selected-tag-box {
  padding-top: 36px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, .05);
  margin-bottom: 36px;

  .title {
    @include font-normal($size: 14px, $color: rgba(0, 0, 0, .5));
    i {
      font-style: normal;
      font-size: 18px;
      color: rgba(0, 0, 0, .75);
      font-weight: 600;
    }
    em{
      font-style: normal;
      margin: 0 8px;
    }
  }

  .el-tag {
    border-radius: 12px;
    margin-left: 12px;
    font-size: 14px;
    cursor: pointer;
    padding: 0 12px;
    color: rgba(0, 0, 0, 0.85);
    background: #fff;
    border: 1px solid rgba(0,0,0,0.85);

    /deep/ .el-tag__close {
      font-size: 14px;
      right: -2px;
      color: rgba(0, 0, 0, 1);
    }

    /deep/ .el-tag__close:hover {
      background: none;
      color: rgba(0, 0, 0, 1);
    }
  }

  .clean {
    @include font-normal($size: 12px, $color: #4d4d4f);
    line-height: 17px;
    margin-left: 12px;
    cursor: pointer;
  }
}
.second-label {
  display: flex;
  .title{
    margin-top: 8px;
    font-weight: 500;
  }
  .s-title{
    min-width: 50px;
    margin-top: 8px;
    color: #E52A0D;
  }
  .tags-wrap{
    flex: 1;
    min-width: 0;
    span{
      margin-top: 8px;
      margin-bottom: 6px;
    }
  }
}
.third-label {
  padding: 10px 20px 4px;
  background: #FAFAFA;
  border-radius: 4px;
  margin: 4px 0 4px 30px;
  .tags-wrap {
    span {
      margin-bottom: 6px;
      background: transparent;
      &:hover{
        background: transparent;
      }
    }
  }
}
.active_label{
  // background: #FDF4F3!important;
  // color: #E52A0D;
  background: #E52A0D!important;
  // background-color: #E52A0D;
  color: #fff;
}
.t_active_label {
  // color: #E52A0D;
  background: #E52A0D!important;
  color: #fff;
}
</style>
